import Image from 'next/image';
import classes from './TwoColumnCopyImage.module.scss';

export default function TwoColumnCopyImage({ data }) {
    let List = data?.listItems;
    let blockTheme = data?.theme;
    let isAnchor = data?.isAnchor;
    return (
        <div
            className={`${classes.oTwoColumnCopyImage} ${classes[`${data.id}`]} ${
                classes[`${data.theme}`]
            } ${classes[`${data.imagePosition}`]}`}
        >
            {isAnchor && <div className={`${classes.isAnchor}`} id={data.id}></div>}

            <div className={classes.oWrapper}>
                <div className={classes.oImage}>
                    <figure
                        className={`${classes.mImage} ${classes[`${data.theme}`]}`}
                        style={{
                            maxWidth: `${data.image.width}px`
                        }}
                    >
                        <Image
                            src={data.image?.url}
                            width={data.image?.width}
                            height={data.image?.height}
                            alt={data.image?.title}
                            layout="responsive"
                            id={data.image?.id}
                            className={classes.aImage}
                        />
                    </figure>
                </div>
                <div className={classes.oCopy}>
                    {data.title && <p className={`${classes.aTitle} fnt16r`}>{data.title}</p>}
                    {data.heading && (
                        <h2 className={`${classes.aHeading} fnt38f fnt-b`}>{data.heading}</h2>
                    )}
                    {blockTheme === 'icon' ? (
                        <div
                            className={`${classes.aCopy} ${classes.aCopy18} fnt18f`}
                            dangerouslySetInnerHTML={{ __html: data.copy }}
                        ></div>
                    ) : (
                        <div
                            className={`${classes.aCopy} ${classes.aCopy18} fnt18f`}
                            dangerouslySetInnerHTML={{ __html: data.copy }}
                        ></div>
                    )}

                    {data.listItems && (
                        <ul className={classes.mBlockList}>
                            {List.map((item) => (
                                <li className={classes.mItem} key={item.id}>
                                    <p className={`${classes.itemText} fnt18s`}>{item.copy}</p>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
}
